import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import toast from 'react-hot-toast';
import SimpleReactValidator from 'simple-react-validator';

import Loading from '../loading';

export default class InputContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: '',
			phone: '',
			message: '',
			isLoading: false,
		};
		this.validator = new SimpleReactValidator({ autoForceUpdate: this });
	}

	sendMessage(name, phone, message) {
		console.log(name, phone, message);
		if (this.validator.allValid()) {
			this.setState({
				isLoading: true,
			});

			toast.success('Message Sent');
			this.props.onCloseModal();
		} else {
			this.validator.showMessages();
			this.forceUpdate();
		}
	}

	render() {
		const { name, phone, message } = this.state;
		const { open, onCloseModal } = this.props;
		return (
			<Modal
				classNames={{
					modal: `contact-modal`,
					closeButton: 'close-btn',
				}}
				open={open}
				onClose={onCloseModal}>
				<div className="inner">
					<div className="icon">
						<i className="fad fa-envelope"></i>
					</div>
					<div className="content">
						<h3>Text Us Now</h3>

						<div className="input-fields">
							<input
								name={'Your Name'}
								type={'text'}
								value={name}
								onChange={({ target }) => this.setState({ name: target.value })}
								placeholder={'Your Name'}
								className="form-control"
							/>
							{this.validator.message('Name', this.state.name, 'required|string')}

							<input
								name={'Phone Number'}
								type={'text'}
								value={phone}
								required={true}
								onChange={({ target }) => this.setState({ phone: target.value })}
								placeholder={'Phone Number'}
								className="form-control"
							/>
							{this.validator.message('Phone Number', this.state.phone, 'required|phone')}

							<textarea
								rows="4"
								name={'Message'}
								type={'text'}
								value={message}
								required={true}
								onChange={({ target }) => this.setState({ message: target.value })}
								placeholder={'Message'}
								className="form-control"></textarea>
							{this.validator.message('Message', this.state.message, 'required|string')}
						</div>

						<div className="buttons">
							<button className="btn btn-default" onClick={() => this.props.onCloseModal()}>
								Cancel
							</button>

							<button
								disabled={this.state.isLoading}
								className="btn btn-confirm"
								onClick={() => this.sendMessage(name, phone, message)}>
								{this.state.isLoading && <Loading />}
								<span>Submit</span>
							</button>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}
